export const categoryBadge = {
  // fontSize: `70%`,
  color: `navy`,
  // verticalAlign: `text-top`,
  fontWeight: `bold`,
  backgroundColor: `lightblue`,
  p: `3px 8px`
  // borderRadius: `6px`,
}
